var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Box as MuiBox, Typography, useMediaQuery, useTheme, } from '@mui/material';
import OfferListStoryIcon from '../../molecules/OfferListStoryIcon';
import OfferListMaterialIcon from '../../molecules/OfferListMaterialIcon';
var Box = styled(MuiBox)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  a {\n    margin-left: 16px;\n    color: #333;\n  }\n"], ["\n  a {\n    margin-left: 16px;\n    color: #333;\n  }\n"])));
var OfferListTitle = function (_a) {
    var offerList = _a.offerList;
    var t = useTranslation().t;
    var country = offerList.producer.country, offerListName = offerList.name;
    var countryName = React.useMemo(function () { return t("countries.".concat(country), { lng: 'en' }); }, [t, country]);
    var theme = useTheme();
    var isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    return (React.createElement(Typography, { component: Box, variant: "h5", display: "flex", justifyContent: isMobile ? 'space-between' : 'flex-start', flexWrap: "nowrap", my: 1 },
        React.createElement(Box, null,
            countryName,
            " / ",
            offerListName),
        React.createElement(Box, { whiteSpace: "nowrap", display: "flex", flexWrap: "nowrap" },
            React.createElement(OfferListStoryIcon, { offerList: offerList }),
            React.createElement(OfferListMaterialIcon, { offerList: offerList }))));
};
export default OfferListTitle;
var templateObject_1;
